export const shipmentConstants = {
  GET_ALL_SHIPMENTS: 'GET_ALL_SHIPMENTS',
  GET_ALL_TO_ASIGN: 'GET_ALL_TO_ASIGN',
  GET_ALL_ACTUALS: 'GET_ALL_ACTUALS',
  GET_ALL_MODIFICATIONS: 'GET_ALL_MODIFICATIONS',
  GET_ALL_RELATION_CHAINS: 'GET_ALL_RELATION_CHAINS',
  GET_RELATION_CHAIN: 'GET_RELATION_CHAIN',
}
